export const REGEX = {
    blankSpace: /^(\S+$)/g,
};
